const VocEndpoints = {
  GET_VOC_COUNTS: (workspaceId: string | null) => `/voc-counts/?workspace_id=${workspaceId}`,
  GET_UPLOAD_HISTORIES: (offset: number, limit: number, workspaceId: string) =>
    `/upload-histories/?offset=${offset}&limit=${limit}&workspace_id=${workspaceId}`,
  SEARCH: (workspaceId: string) => `/vocs/search/?workspace_id=${workspaceId}`,
  DOWNLOAD_SEARCH_RESULT: (workspaceId: string) => `/vocs/search/download/?workspace_id=${workspaceId}`,
  GET_VOC_CHAR_COUNT: (start: string, end: string, workspaceId: string) =>
    `/vocs/char-count/?start=${start}&end=${end}&workspace_id=${workspaceId}`,
};

export default VocEndpoints;
